export * from './notificacao-icone/notificacao-icone.module';
export * from './notificacoes-detalhes/notificacoes-detalhes.module';

